import styled, { keyframes } from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const RailsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px;
  align-items: stretch;
  margin-top: 26px;

  ${screen.lg} {
    grid-template-columns: 1fr 1fr;
    gap: 28px;
  }
`;

export const RailCard = styled.div`
  border: 1px solid ${homeColor.line};
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.025);
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const DiagramSvg = styled.svg`
  width: 100%;
  display: block;
`;

const dash = keyframes`
  to { stroke-dashoffset: -30; }
`;

export const FlowPath = styled.path`
  stroke-dasharray: 2 8;
  animation: ${dash} 1.1s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const RailStack = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
`;

export const Beat = styled.div`
  border: 1px solid ${homeColor.line};
  border-radius: 12px;
  padding: 15px 17px;
  background: ${homeColor.surface2};

  &.out {
    border-color: rgba(20, 214, 77, 0.32);
  }
`;

export const BeatHeading = styled.div`
  font-family: ${getToken('font-family-default')};
  font-size: 11px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${homeColor.muted2};
  margin-bottom: 7px;
`;

export const BeatText = styled.div`
  font-family: ${getToken('font-family-default')};
  font-size: 14px;
  font-weight: 500;
  color: ${homeColor.white};

  b {
    color: ${homeColor.green};
  }
`;

export const BeatStamp = styled.div`
  font-family: ${getToken('font-family-default')};
  font-size: 11px;
  color: ${homeColor.cyan};
  margin-top: 8px;
`;

export const Ledger = styled.div`
  margin-top: 26px;
  border-top: 1px solid ${homeColor.carbon};
`;

export const LedgerRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 17px 4px;
  border-bottom: 1px solid ${homeColor.carbon};

  svg {
    width: 26px;
    height: 26px;
    flex: none;
    stroke: ${homeColor.green};
    fill: none;
    stroke-width: 1.3;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
`;

export const LedgerTitle = styled.span`
  font-family: ${getToken('font-family-default')};
  font-weight: 600;
  font-size: 15px;
  color: ${homeColor.white};
  min-width: 150px;
`;

export const LedgerDescription = styled.span`
  font-family: ${getToken('font-family-default')};
  color: ${homeColor.muted};
  font-size: 13px;
  flex: 1;
`;
